import keepDecimal from './keepDecimal';

/**
 * 将 px 单位转成类似 vw 的自适应数值
 * @param {string | number} str 可传字符串或数字，如果是数字，则会根据设计稿宽度计算出当前视口相同比例的px值。其他情况则不会改变，如"1rem"、"20px"等
 * @param {number} viewportWidth 设计稿宽度，默认750px
 * @param {boolean} hasUnit 返回值是否需要有"px"单位，默认true
 * @return {string | number} ...px
 */
const px2vw = (str: string | number, viewportWidth = 750, hasUnit = true): string | number => {
  const clientWidth = window.innerWidth;
  if (typeof str === 'number') {
    const result = keepDecimal((str / viewportWidth) * clientWidth);
    return hasUnit ? result + 'px' : result;
  } else {
    return str;
  }
};

export default px2vw;
